// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});

//   const itemsPerPage = 4;
//   const navigate = useNavigate();

//   // ✅ Fetch all data
//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       // Always fetch recommended products (public endpoint)
//       const popularRes = await fetch('https://backend.frozenwala.com/api/recommended/');
//       const popularData = await popularRes.json();
//       setGetProduct(popularData);
//       console.log("popular items : ", popularData);

//       try{
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       }
//       catch(stockErr){
//         console.error("Error fetching stock data:", stockErr);
//       }

//       // Only fetch cart and stock if user is logged in
//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);

//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart/stock");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     }
//   };

//   useEffect(() => {console.log("Stock updated:", stock)}, [stock])

//   // ✅ Auto slide carousel
//   useEffect(() => {
//     if (getProduct.length > 0) {
//       const interval = setInterval(() => handleScroll("next"), 3500);
//       return () => clearInterval(interval);
//     }
//   }, [getProduct]);

//   const handleScroll = (direction) => {
//     const totalSlides = Math.ceil(getProduct.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   const visibleItems = [];
//   for (let i = 0; i < getProduct.length; i += itemsPerPage) {
//     visibleItems.push(getProduct.slice(i, i + itemsPerPage));
//   }

//   // ✅ Add to cart logic
//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     const uid = localStorage.getItem("user_id");
//     if (!accessToken || !uid) {
//       navigate("/login");
//       return;
//     }

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   // ✅ Increase/Decrease quantity
//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     const uid = localStorage.getItem("user_id");
//     if (!accessToken || !uid) {
//       navigate("/login");
//       return;
//     }

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     const uid = localStorage.getItem("user_id");
//     if (!accessToken || !uid) {
//       navigate("/login");
//       return;
//     }

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   return (
//     <section className="popular-section py-4 overflow-hidden">
//       <div className="container text-center">
//         <motion.h5
//           className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           style={{textAlign: "left"}}
//         >
//           Recommended for You
//         </motion.h5>

//         {getProduct.length === 0 ? (
//           <div className="text-center py-5">
//             <p>No recommended products available</p>
//           </div>
//         ) : (
//           <div className="position-relative">
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={currentSlide}
//                 className="row gx-4"
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -100 }}
//                 transition={{ duration: 0.6 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   const isSoldOut = stock[item.id] === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <motion.div
//                       key={item.id}
//                       className="col-6 col-sm-6 col-md-4 col-lg-3"
//                       // whileHover={{ scale: 1.03 }}
//                       // transition={{ type: "spring", stiffness: 150 }}
//                     >
//                       <div className="card card-span border-0 h-70 p-0 rounded-4 position-relative small-card">
//                         {/* Sold out badge */}
//                         {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

//                         {/* ❤️ Wishlist Icon */}
//                         <div
//                           onClick={() => !wishlistLoading && toggleWishlist(item)}
//                           style={{
//                             position: "absolute",
//                             top: "15px",
//                             right: "15px",
//                             cursor: "pointer",
//                           }}
//                         >
//                           {isInWishlist ? (
//                             <FaHeart size={26} color="red" />
//                           ) : (
//                             <CiHeart size={26} color="#bbb" />
//                           )}
//                         </div>

//                         <motion.img
//                           src={item.item_photo || logo}
//                           alt={item.title}
//                           className="img-fluid rounded-4 w-100 popular-img"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => navigate(`products/${item.id}`)}
//                         />

//                         <div className="card-body px-0 text-center">
//                           <h6
//                             className="fw-bold text-truncate"
//                             style={{ textAlign: "left" }}
//                           >
//                             {item.title}
//                           </h6>
//  <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
//                         <p
//                         className="old-price"
//                         style={{
//                           textDecoration: `${item.item_old_price === item.item_new_price ? "auto" : "line-through"}`,
//                           color: "#999",
//                           fontSize: "0.83333rem",
//                         }}
//                       >
//                         ₹{item.item_old_price || 0}
//                       </p>
//                           <p className="fw-bold" style={{fontSize: "0.83333rem"}}>
//                             ₹{item.item_new_price}
//                           </p>
                          
//                        <p className="discount-badge" style={{ 
//         color: 'green', 
//         fontSize: '0.83333rem', 
//       }}>
//         {item.discount_percentage}% OFF
//       </p>
//       </div>
//                           {cartQty && !isSoldOut && isLoggedIn ? (
//                             <div className="d-flex justify-content-center align-items-center gap-2">
//                               <button className="qty-btn" onClick={() => subOne(item.id)}>
//                                 -
//                               </button>
//                               <span className="fw-bold">{cartQty}</span>
//                               <button className="qty-btn" onClick={() => addOne(item.id)}>
//                                 +
//                               </button>
//                             </div>
//                           ) : (
//                            <button
//                             className="btn btn-danger btn-sm rounded-pill"
//                             onClick={() => onPressAddToCart(item.id)}
//                             disabled={isSoldOut}
//                             style={{padding: "6px 12px", fontSize: "12px"}}
//                           >
//                             Add to Cart
//                           </button> 
//                           )}
//                         </div>
//                       </div>
//                     </motion.div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart, selectedBrands = [], filterByBrands }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});

//   const itemsPerPage = 4;
//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // ✅ Fetch all data
//   useEffect(() => {
//     fetchData();
//   }, []);

//   // ✅ Filter products when selectedBrands changes
//   useEffect(() => {
//     console.log("Filtering products...");
//     console.log("Selected brands:", selectedBrands);
//     console.log("All products:", getProduct);
    
//     if (getProduct.length > 0) {
//       let filtered;
//       if (filterByBrands) {
//         filtered = filterByBrands(getProduct);
//       } else {
//         // Fallback filtering
//         if (selectedBrands.length === 0) {
//           filtered = getProduct;
//         } else {
//           filtered = getProduct.filter(product => {
//             console.log(`Product: ${product.title}, Brand: ${product.brand_name}`);
//             return product.brand_name && selectedBrands.includes(product.brand_name);
//           });
//         }
//       }
      
//       console.log("Filtered products:", filtered);
//       setFilteredProducts(filtered);
//       // Reset current slide when products change
//       setCurrentSlide(0);
//     }
//   }, [getProduct, selectedBrands, filterByBrands]);

//   const fetchData = async () => {
//     try {
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       // Fetch recommended products (public endpoint)
//       const popularRes = await fetch('https://backend.frozenwala.com/api/recommended/');
//       const popularData = await popularRes.json();
      
//       console.log("Fetched recommended items:", popularData);
//       // Check if products have brand_name field
//       if (popularData.length > 0) {
//         console.log("Sample product fields:", Object.keys(popularData[0]));
//         console.log("Sample product brand_name:", popularData[0].brand_name);
//       }
      
//       setGetProduct(popularData);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       // Only fetch cart if user is logged in
//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     }
//   };

//   // ✅ Auto slide carousel
//   useEffect(() => {
//     if (filteredProducts.length > 0) {
//       const interval = setInterval(() => handleScroll("next"), 3500);
//       return () => clearInterval(interval);
//     }
//   }, [filteredProducts]);

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   // ✅ Add to cart logic
//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   // ✅ Increase/Decrease quantity
//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   // Show message when no products match the selected brands
//   if (filteredProducts.length === 0 && getProduct.length > 0) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             style={{ textAlign: "left" }}
//           >
//             Recommended for You
//           </motion.h5>
//           <div className="text-center py-5">
//             <p>No products match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4 overflow-hidden">
//       <div className="container text-center">
//         <motion.h5
//           className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           style={{ textAlign: "left" }}
//         >
//           Recommended for You
//         </motion.h5>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading recommended products...</p>
//           </div>
//         ) : (
//           <div className="position-relative">
//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={currentSlide}
//                 className="row gx-4"
//                 initial={{ opacity: 0, x: 100 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -100 }}
//                 transition={{ duration: 0.6 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   console.log("item ???????????????? : ",item)
//                   // const isSoldOut = stock[item.id] === 0;
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <motion.div
//                       key={item.id}
//                       className="col-6 col-sm-6 col-md-4 col-lg-3"
//                     >
//                       <div className="card card-span border-0 h-70 p-0 rounded-4 position-relative small-card">
//                         {/* Sold out badge */}
//                         {isSoldOut && <div className="sold-out-badge">Sold Out</div>}

//                         {/* ❤️ Wishlist Icon */}
//                         <div
//                           onClick={() => !wishlistLoading && toggleWishlist(item)}
//                           style={{
//                             position: "absolute",
//                             top: "15px",
//                             right: "15px",
//                             cursor: "pointer",
//                           }}
//                         >
//                           {isInWishlist ? (
//                             <FaHeart size={26} color="red" />
//                           ) : (
//                             <CiHeart size={26} color="#bbb" />
//                           )}
//                         </div>

//                         <motion.img
//                           src={item.item_photo || logo}
//                           alt={item.title}
//                           className="img-fluid rounded-4 w-100 popular-img"
//                           style={{ cursor: "pointer" }}
//                           onClick={() => navigate(`products/${item.id}`)}
//                         />

//                         <div className="card-body px-0 text-center">
                         
//                           <h6
//                             className="fw-bold text-truncate"
//                             style={{ textAlign: "left" }}
//                           >
//                             {item.title}
//                           </h6>
//                           <div style={{ display: "flex", alignItems: "center", gap: "7px", marginTop: "3px" }}>
//                             <p
//                               className="old-price"
//                               style={{
//                                 textDecoration: `${item.item_old_price === item.item_new_price ? "auto" : "line-through"}`,
//                                 color: "#999",
//                                 fontSize: "0.83333rem",
//                               }}
//                             >
//                               ₹{item.item_old_price || 0}
//                             </p>
//                             <p className="fw-bold" style={{ fontSize: "0.83333rem" }}>
//                               ₹{item.item_new_price}
//                             </p>
//                             <p className="discount-badge" style={{ 
//                               color: 'green', 
//                               fontSize: '0.83333rem', 
//                             }}>
//                               {item.discount_percentage}% OFF
//                             </p>
//                           </div>
//                           {cartQty && !isSoldOut && isLoggedIn ? (
//                             <div className="d-flex justify-content-center align-items-center gap-2">
//                               <button className="qty-btn" onClick={() => subOne(item.id)}>
//                                 -
//                               </button>
//                               <span className="fw-bold">{cartQty}</span>
//                               <button className="qty-btn" onClick={() => addOne(item.id)}>
//                                 +
//                               </button>
//                             </div>
//                           ) : (
//                             <button
//                               className="btn btn-danger btn-sm rounded-pill"
//                               onClick={() => onPressAddToCart(item.id)}
//                               disabled={isSoldOut}
//                               style={{ padding: "6px 12px", fontSize: "12px" }}
//                             >
//                               Add to Cart
//                             </button>
//                           )}
//                         </div>
//                       </div>
//                     </motion.div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;


// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [loading, setLoading] = useState(false);
  
//   // Dynamic items per page state based on viewport width
//   const [itemsPerPage, setItemsPerPage] = useState(4);

//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // Handle responsive items calculation on screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width < 576) {
//         setItemsPerPage(2); // Mobile view screen grid columns
//       } else if (width < 992) {
//         setItemsPerPage(3); // Tablet view screen grid columns
//       } else {
//         setItemsPerPage(4); // Desktop screen grid columns
//       }
//     };

//     handleResize(); // Initialize value immediately
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       let url = 'https://backend.frozenwala.com/api/recommended/';

//       if (selectedBrands && selectedBrands.length > 0) {
//         const brandsParam = selectedBrands.join(',');
//         url += `?brand=${encodeURIComponent(brandsParam)}`;
//       }

//       const popularRes = await fetch(url);
//       const popularData = await popularRes.json();
//       setGetProduct(popularData);
//       setFilteredProducts(popularData);

//       setCurrentSlide(0);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   // Re-calculate the layout chunks dynamically when window width changes
//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   const moduleStyles = (
//     <style>{`
//       .popular-section {
//         overflow: visible !important;
//       }
//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       .symmetric-image-frame::after {
//         content: "";
//         position: absolute;
//         top: 0;
//         left: -75%;
//         width: 50%;
//         height: 100%;
//         background: linear-gradient(
//           90deg,
//           rgba(255, 255, 255, 0) 0%,
//           rgba(255, 255, 255, 0.5) 50%,
//           rgba(255, 255, 255, 0) 100%
//         );
//         transform: skewX(-25deg);
//         transition: left 0.4s ease-out;
//         pointer-events: none;
//         z-index: 2;
//       }
//       .premium-card-wrapper:hover .symmetric-image-frame::after {
//         left: 125%;
//       }

//       .skeleton-block {
//         background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
//         background-size: 200% 100%;
//         animation: skeleton-pulse 1.5s infinite ease-in-out;
//       }
//       @keyframes skeleton-pulse {
//         0% { background-position: 200% 0; }
//         100% { background-position: -200% 0; }
//       }
//       .skeleton-title {
//         height: 16px;
//         width: 75%;
//         border-radius: 4px;
//         margin-bottom: 12px;
//       }
//       .skeleton-meta {
//         height: 14px;
//         width: 50%;
//         border-radius: 4px;
//         margin-bottom: 20px;
//       }
//       .skeleton-btn {
//         height: 35px;
//         width: 100%;
//         border-radius: 50px;
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container {
//           --bs-gutter-x: 0.5rem !important;
//         }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//       }
//     `}</style>
//   );

//   const premiumArrowStyle = {
//     position: "absolute",
//     top: "50%",
//     transform: "translateY(-50%)",
//     zIndex: 10,
//     background: "rgba(255, 255, 255, 0.95)",
//     backdropFilter: "blur(6px)",
//     borderRadius: "50%",
//     width: "clamp(36px, 5vw, 44px)",
//     height: "clamp(36px, 5vw, 44px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "2px solid #5dc5fa",
//     color: "#5dc5fa",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     fontSize: "clamp(14px, 2vw, 18px)",
//     padding: 0,
//     outline: "none"
//   };

//   if (loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center px-2">
//           {moduleStyles}
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             style={{ textAlign: "left" }}
//           >
//             Recommended for You
//           </motion.h5>

//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4].map((n) => (
//               <div key={n} className="col-6 col-sm-4 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     );
//   }

//   if (filteredProducts.length === 0 && !loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             style={{ textAlign: "left" }}
//           >
//             Recommended for You
//           </motion.h5>
//           <div className="text-center py-5">
//             <p>No products match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4">
//       <div className="container text-center px-2">
//         {moduleStyles}

//         <motion.h5
//           className="fw-bold fs-3 lh-sm mb-4 text-gradient"
//           initial={{ opacity: 0, y: -30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6 }}
//           style={{ textAlign: "left" }}
//         >
//           Recommended for You
//         </motion.h5>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading recommended products...</p>
//           </div>
//         ) : (
//           <div className="position-relative px-0 px-md-2">
//             {filteredProducts.length > itemsPerPage && (
//               <>
//                 <button
//                   className="carousel-control-prev premium-arrow-btn-layout"
//                   onClick={() => handleScroll("prev")}
//                   style={{ ...premiumArrowStyle, left: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronLeft />
//                 </button>
//                 <button
//                   className="carousel-control-next premium-arrow-btn-layout"
//                   onClick={() => handleScroll("next")}
//                   style={{ ...premiumArrowStyle, right: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronRight />
//                 </button>
//               </>
//             )}

//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={`${currentSlide}-${itemsPerPage}`}
//                 className="row gy-4 product-grid-container justify-content-start"
//                 initial={{ opacity: 0, x: 40 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -40 }}
//                 transition={{ duration: 0.4, ease: "easeInOut" }}
//                 drag="x"
//                 dragConstraints={{ left: 0, right: 0 }}
//                 dragElastic={0.2}
//                 onDragEnd={(e, info) => {
//                   if (info.offset.x > 50) {
//                     handleScroll("prev");
//                   } else if (info.offset.x < -50) {
//                     handleScroll("next");
//                   }
//                 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <div
//                       key={item.id}
//                       className="col-6 col-sm-4 col-md-4 col-lg-3"
//                     >
//                       <div className="card h-100 border-0 premium-card-wrapper">
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               if (!wishlistLoading) toggleWishlist(item);
//                             }}
//                             style={{
//                               position: "absolute",
//                               top: "10px",
//                               right: "10px",
//                               cursor: "pointer",
//                               zIndex: 2,
//                             }}
//                           >
//                             {isInWishlist ? (
//                               <FaHeart size={20} color="red" />
//                             ) : (
//                               <CiHeart size={20} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />
//                             )}
//                           </div>

//                           <motion.img
//                             src={item.item_photo || logo}
//                             alt={item.title}
//                             className="symmetric-cover-img"
//                             style={{ cursor: "pointer" }}
//                             onClick={() => navigate(`products/${item.id}`)}
//                           />
//                         </div>

//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
//                             {item.title}
//                           </h6>
                          
//                           <div className="d-flex align-items-center flex-wrap gap-1 gap-sm-2 mb-3">
//                             <span className="text-muted text-decoration-line-through mobile-price-size" style={{ fontSize: "13px" }}>
//                               ₹{item.item_old_price || 0}
//                             </span>
//                             <span className="fw-bold text-dark mobile-price-size" style={{ fontSize: "14px" }}>
//                               ₹{item.item_new_price}
//                             </span>
//                             <span className="fw-bold" style={{ color: '#28a745', fontSize: "11px" }}>
//                               {item.discount_percentage}% OFF
//                             </span>
//                           </div>

//                           <div className="mt-auto w-100">
//                             {cartQty && !isSoldOut && isLoggedIn ? (
//                               <div className="d-flex justify-content-center align-items-center gap-1 gap-sm-2">
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => subOne(item.id)}>
//                                   -
//                                 </button>
//                                 <span className="fw-bold text-dark mx-1 mx-sm-2" style={{ fontSize: "13px" }}>{cartQty}</span>
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => addOne(item.id)}>
//                                   +
//                                 </button>
//                               </div>
//                             ) : (
//                               <button
//                                 className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                                 onClick={() => onPressAddToCart(item.id)}
//                                 disabled={isSoldOut}
//                                 style={{ backgroundColor: "#5dc5fa", border: "none", padding: "6px 0", fontSize: "12px" }}
//                               >
//                                 Add to Cart
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>

//             {filteredProducts.length > itemsPerPage && (
//               <div className="carousel-dots" style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
//                 {visibleItems.map((_, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setCurrentSlide(idx)}
//                     style={{
//                       width: "8px",
//                       height: "8px",
//                       borderRadius: "50%",
//                       background: currentSlide === idx ? "#5dc5fa" : "#ddd",
//                       border: "none",
//                       padding: "0",
//                       cursor: "pointer"
//                     }}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

// Popular.jsx - Updated with View All button

// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [loading, setLoading] = useState(false);
  
//   // Dynamic items per page state based on viewport width
//   const [itemsPerPage, setItemsPerPage] = useState(4);

//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // Handle responsive items calculation on screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width < 576) {
//         setItemsPerPage(2); // Mobile view screen grid columns
//       } else if (width < 992) {
//         setItemsPerPage(3); // Tablet view screen grid columns
//       } else {
//         setItemsPerPage(4); // Desktop screen grid columns
//       }
//     };

//     handleResize(); // Initialize value immediately
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       let url = 'https://backend.frozenwala.com/api/recommended/';

//       if (selectedBrands && selectedBrands.length > 0) {
//         const brandsParam = selectedBrands.join(',');
//         url += `?brand=${encodeURIComponent(brandsParam)}`;
//       }

//       const popularRes = await fetch(url);
//       const popularData = await popularRes.json();
//       setGetProduct(popularData);
//       setFilteredProducts(popularData);

//       setCurrentSlide(0);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   // Re-calculate the layout chunks dynamically when window width changes
//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   // Navigate to view all page
//   const handleViewAll = () => {
//     navigate('/recommended-products', { 
//       state: { 
//         products: filteredProducts,
//         selectedBrands: selectedBrands
//       } 
//     });
//   };

//   const moduleStyles = (
//     <style>{`
//       .popular-section {
//         overflow: visible !important;
//       }
//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       .symmetric-image-frame::after {
//         content: "";
//         position: absolute;
//         top: 0;
//         left: -75%;
//         width: 50%;
//         height: 100%;
//         background: linear-gradient(
//           90deg,
//           rgba(255, 255, 255, 0) 0%,
//           rgba(255, 255, 255, 0.5) 50%,
//           rgba(255, 255, 255, 0) 100%
//         );
//         transform: skewX(-25deg);
//         transition: left 0.4s ease-out;
//         pointer-events: none;
//         z-index: 2;
//       }
//       .premium-card-wrapper:hover .symmetric-image-frame::after {
//         left: 125%;
//       }

//       .skeleton-block {
//         background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
//         background-size: 200% 100%;
//         animation: skeleton-pulse 1.5s infinite ease-in-out;
//       }
//       @keyframes skeleton-pulse {
//         0% { background-position: 200% 0; }
//         100% { background-position: -200% 0; }
//       }
//       .skeleton-title {
//         height: 16px;
//         width: 75%;
//         border-radius: 4px;
//         margin-bottom: 12px;
//       }
//       .skeleton-meta {
//         height: 14px;
//         width: 50%;
//         border-radius: 4px;
//         margin-bottom: 20px;
//       }
//       .skeleton-btn {
//         height: 35px;
//         width: 100%;
//         border-radius: 50px;
//       }

//       .view-all-btn {
//         color: #5dc5fa;
//         font-weight: 600;
//         font-size: 14px;
//         text-decoration: none;
//         padding: 6px 16px;
//         border-radius: 50px;
//         border: 2px solid #5dc5fa;
//         background: transparent;
//         transition: all 0.3s ease;
//         white-space: nowrap;
//       }
//       .view-all-btn:hover {
//         background: #5dc5fa;
//         color: #fff;
//         transform: translateX(4px);
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container {
//           --bs-gutter-x: 0.5rem !important;
//         }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//         .view-all-btn {
//           font-size: 12px;
//           padding: 4px 12px;
//         }
//       }
//     `}</style>
//   );

//   const premiumArrowStyle = {
//     position: "absolute",
//     top: "50%",
//     transform: "translateY(-50%)",
//     zIndex: 10,
//     background: "rgba(255, 255, 255, 0.95)",
//     backdropFilter: "blur(6px)",
//     borderRadius: "50%",
//     width: "clamp(36px, 5vw, 44px)",
//     height: "clamp(36px, 5vw, 44px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "2px solid #5dc5fa",
//     color: "#5dc5fa",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     fontSize: "clamp(14px, 2vw, 18px)",
//     padding: 0,
//     outline: "none"
//   };

//   if (loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center px-2">
//           {moduleStyles}
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <motion.h5
//               className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//               initial={{ opacity: 0, y: -30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               Recommended for You
//             </motion.h5>
//           </div>

//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4].map((n) => (
//               <div key={n} className="col-6 col-sm-4 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     );
//   }

//   if (filteredProducts.length === 0 && !loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <motion.h5
//               className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//               initial={{ opacity: 0, y: -30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               Recommended for You
//             </motion.h5>
//           </div>
//           <div className="text-center py-5">
//             <p>No products match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4">
//       <div className="container text-center px-2">
//         {moduleStyles}

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             Recommended for You
//           </motion.h5>
          
//           {filteredProducts.length > 0 && (
//             <motion.button
//               className="view-all-btn"
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               onClick={handleViewAll}
//             >
//               View All →
//             </motion.button>
//           )}
//         </div>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading recommended products...</p>
//           </div>
//         ) : (
//           <div className="position-relative px-0 px-md-2">
//             {filteredProducts.length > itemsPerPage && (
//               <>
//                 <button
//                   className="carousel-control-prev premium-arrow-btn-layout"
//                   onClick={() => handleScroll("prev")}
//                   style={{ ...premiumArrowStyle, left: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronLeft />
//                 </button>
//                 <button
//                   className="carousel-control-next premium-arrow-btn-layout"
//                   onClick={() => handleScroll("next")}
//                   style={{ ...premiumArrowStyle, right: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronRight />
//                 </button>
//               </>
//             )}

//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={`${currentSlide}-${itemsPerPage}`}
//                 className="row gy-4 product-grid-container justify-content-start"
//                 initial={{ opacity: 0, x: 40 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -40 }}
//                 transition={{ duration: 0.4, ease: "easeInOut" }}
//                 drag="x"
//                 dragConstraints={{ left: 0, right: 0 }}
//                 dragElastic={0.2}
//                 onDragEnd={(e, info) => {
//                   if (info.offset.x > 50) {
//                     handleScroll("prev");
//                   } else if (info.offset.x < -50) {
//                     handleScroll("next");
//                   }
//                 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <div
//                       key={item.id}
//                       className="col-6 col-sm-4 col-md-4 col-lg-3"
//                     >
//                       <div className="card h-100 border-0 premium-card-wrapper">
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               if (!wishlistLoading) toggleWishlist(item);
//                             }}
//                             style={{
//                               position: "absolute",
//                               top: "10px",
//                               right: "10px",
//                               cursor: "pointer",
//                               zIndex: 2,
//                             }}
//                           >
//                             {isInWishlist ? (
//                               <FaHeart size={20} color="red" />
//                             ) : (
//                               <CiHeart size={20} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />
//                             )}
//                           </div>

//                           <motion.img
//                             src={item.item_photo || logo}
//                             alt={item.title}
//                             className="symmetric-cover-img"
//                             style={{ cursor: "pointer" }}
//                             onClick={() => navigate(`products/${item.id}`)}
//                           />
//                         </div>

//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" style={{ fontSize: "14px" }}>
//                             {item.title}
//                           </h6>
                          
//                           <div className="d-flex align-items-center flex-wrap gap-1 gap-sm-2 mb-3">
//                             <span className="text-muted text-decoration-line-through mobile-price-size" style={{ fontSize: "13px" }}>
//                               ₹{item.item_old_price || 0}
//                             </span>
//                             <span className="fw-bold text-dark mobile-price-size" style={{ fontSize: "14px" }}>
//                               ₹{item.item_new_price}
//                             </span>
//                             <span className="fw-bold" style={{ color: '#28a745', fontSize: "11px" }}>
//                               {item.discount_percentage}% OFF
//                             </span>
//                           </div>

//                           <div className="mt-auto w-100">
//                             {cartQty && !isSoldOut && isLoggedIn ? (
//                               <div className="d-flex justify-content-center align-items-center gap-1 gap-sm-2">
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => subOne(item.id)}>
//                                   -
//                                 </button>
//                                 <span className="fw-bold text-dark mx-1 mx-sm-2" style={{ fontSize: "13px" }}>{cartQty}</span>
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => addOne(item.id)}>
//                                   +
//                                 </button>
//                               </div>
//                             ) : (
//                               <button
//                                 className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                                 onClick={() => onPressAddToCart(item.id)}
//                                 disabled={isSoldOut}
//                                 style={{ backgroundColor: "#5dc5fa", border: "none", padding: "6px 0", fontSize: "12px" }}
//                               >
//                                 Add to Cart
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>

//             {filteredProducts.length > itemsPerPage && (
//               <div className="carousel-dots" style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
//                 {visibleItems.map((_, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setCurrentSlide(idx)}
//                     style={{
//                       width: "8px",
//                       height: "8px",
//                       borderRadius: "50%",
//                       background: currentSlide === idx ? "#5dc5fa" : "#ddd",
//                       border: "none",
//                       padding: "0",
//                       cursor: "pointer"
//                     }}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Api from "../Utills/Api";
// import { useNavigate } from "react-router-dom";
// import logo from "../../Frozenwala.png";
// import "./Popular.css";
// import { CiHeart } from "react-icons/ci";
// import { FaHeart, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import { useWishlist } from "../../contexts/WishlistContext";
// import ProductModal from "./ProductModal"; // Add this import

// function Popular({ refreshCart, selectedBrands = [] }) {
//   const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [getProduct, setGetProduct] = useState([]);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [cartItems, setCartItems] = useState({});
//   const [stock, setStock] = useState({});
//   const [loading, setLoading] = useState(false);
  
//   // Modal states - Add these
//   const [selectedProductId, setSelectedProductId] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
  
//   // Dynamic items per page state based on viewport width
//   const [itemsPerPage, setItemsPerPage] = useState(4);

//   const uid = localStorage.getItem("user_id");
//   const navigate = useNavigate();

//   // Handle responsive items calculation on screen resize
//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       if (width < 576) {
//         setItemsPerPage(2); // Mobile view screen grid columns
//       } else if (width < 992) {
//         setItemsPerPage(3); // Tablet view screen grid columns
//       } else {
//         setItemsPerPage(4); // Desktop screen grid columns
//       }
//     };

//     handleResize(); // Initialize value immediately
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     fetchData();
//   }, [selectedBrands]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const accessToken = localStorage.getItem("access_token");
//       const uid = localStorage.getItem("user_id");

//       let url = 'https://backend.frozenwala.com/api/recommended/';

//       if (selectedBrands && selectedBrands.length > 0) {
//         const brandsParam = selectedBrands.join(',');
//         url += `?brand=${encodeURIComponent(brandsParam)}`;
//       }

//       const popularRes = await fetch(url);
//       const popularData = await popularRes.json();
//       setGetProduct(popularData);
//       setFilteredProducts(popularData);

//       setCurrentSlide(0);

//       try {
//         const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
//         const stockMap = {};
//         if (stockRes.data && Array.isArray(stockRes.data)) {
//           stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
//           setStock(stockMap);
//         }
//       } catch (stockErr) {
//         console.error("Error fetching stock data:", stockErr);
//       }

//       if (accessToken && uid) {
//         try {
//           const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
//           const cartMap = {};
//           if (cartRes.data && Array.isArray(cartRes.data)) {
//             cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
//             setCartItems(cartMap);
//           }
//         } catch (authError) {
//           console.log("User not logged in or token expired, skipping cart");
//         }
//       }
//     } catch (err) {
//       console.error("Error loading data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleScroll = (direction) => {
//     if (filteredProducts.length === 0) return;
//     const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
//     setCurrentSlide((prev) =>
//       direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
//     );
//   };

//   // Add this handler for opening modal
//   const handleProductClick = (productId) => {
//     setSelectedProductId(productId);
//     setIsModalOpen(true);
//   };

//   // Add this handler for closing modal
//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedProductId(null);
//   };

//   // Re-calculate the layout chunks dynamically when window width changes
//   const visibleItems = [];
//   for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
//     visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
//   }

//   const onPressAddToCart = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
//       setCartItems((prev) => ({
//         ...prev,
//         [productId]: (prev[productId] || 0) + 1,
//       }));
//       refreshCart();
//     } catch (err) {
//       console.error("Add to cart failed:", err);
//     }
//   };

//   const addOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     const currentQty = cartItems[productId] || 0;
//     const available = stock[productId] || 0;

//     if (available > currentQty) {
//       try {
//         await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
//         setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
//         refreshCart();
//       } catch (err) {
//         console.error("Increase failed:", err);
//       }
//     } else {
//       toast.warning(`Only ${available} items in stock`);
//     }
//   };

//   const subOne = async (productId) => {
//     const accessToken = localStorage.getItem("access_token");
//     if (!accessToken) return navigate("/login");

//     try {
//       await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
//       setCartItems((prev) => {
//         const updated = { ...prev };
//         if (updated[productId] > 1) updated[productId] -= 1;
//         else delete updated[productId];
//         return updated;
//       });
//       refreshCart();
//     } catch (err) {
//       console.error("Decrease failed:", err);
//     }
//   };

//   // Navigate to view all page
//   const handleViewAll = () => {
//     navigate('/recommended-products', { 
//       state: { 
//         products: filteredProducts,
//         selectedBrands: selectedBrands
//       } 
//     });
//   };

//   const moduleStyles = (
//     <style>{`
//       .popular-section {
//         overflow: visible !important;
//       }
//       .premium-card-wrapper {
//         border-radius: 20px !important;
//         padding: 12px !important;
//         background: #ffffff !important;
//         border: 1px solid rgba(0, 0, 0, 0.03) !important;
//         box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
//         transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
//       }
//       .premium-card-wrapper:hover {
//         transform: translateY(-6px);
//         box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
//       }
//       .symmetric-image-frame {
//         position: relative;
//         width: 100%;
//         height: 180px;
//         overflow: hidden;
//         border-radius: 14px !important;
//         background-color: #f7f7f7;
//       }
//       .symmetric-cover-img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover !important;
//         transition: transform 0.3s ease;
//         cursor: pointer;
//       }
//       .premium-card-wrapper:hover .symmetric-cover-img {
//         transform: scale(1.04);
//       }

//       .symmetric-image-frame::after {
//         content: "";
//         position: absolute;
//         top: 0;
//         left: -75%;
//         width: 50%;
//         height: 100%;
//         background: linear-gradient(
//           90deg,
//           rgba(255, 255, 255, 0) 0%,
//           rgba(255, 255, 255, 0.5) 50%,
//           rgba(255, 255, 255, 0) 100%
//         );
//         transform: skewX(-25deg);
//         transition: left 0.4s ease-out;
//         pointer-events: none;
//         z-index: 2;
//       }
//       .premium-card-wrapper:hover .symmetric-image-frame::after {
//         left: 125%;
//       }

//       .skeleton-block {
//         background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
//         background-size: 200% 100%;
//         animation: skeleton-pulse 1.5s infinite ease-in-out;
//       }
//       @keyframes skeleton-pulse {
//         0% { background-position: 200% 0; }
//         100% { background-position: -200% 0; }
//       }
//       .skeleton-title {
//         height: 16px;
//         width: 75%;
//         border-radius: 4px;
//         margin-bottom: 12px;
//       }
//       .skeleton-meta {
//         height: 14px;
//         width: 50%;
//         border-radius: 4px;
//         margin-bottom: 20px;
//       }
//       .skeleton-btn {
//         height: 35px;
//         width: 100%;
//         border-radius: 50px;
//       }

//       .view-all-btn {
//         color: #5dc5fa;
//         font-weight: 600;
//         font-size: 14px;
//         text-decoration: none;
//         padding: 6px 16px;
//         border-radius: 50px;
//         border: 2px solid #5dc5fa;
//         background: transparent;
//         transition: all 0.3s ease;
//         white-space: nowrap;
//       }
//       .view-all-btn:hover {
//         background: #5dc5fa;
//         color: #fff;
//         transform: translateX(4px);
//       }

//       @media (max-width: 575.98px) {
//         .product-grid-container {
//           --bs-gutter-x: 0.5rem !important;
//         }
//         .premium-card-wrapper {
//           padding: 8px !important;
//           border-radius: 16px !important;
//           box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
//         }
//         .symmetric-image-frame {
//           height: 135px;
//           border-radius: 10px !important;
//         }
//         .mobile-title-size {
//           font-size: 13px !important;
//         }
//         .mobile-price-size {
//           font-size: 12px !important;
//         }
//         .view-all-btn {
//           font-size: 12px;
//           padding: 4px 12px;
//         }
//       }
//     `}</style>
//   );

//   const premiumArrowStyle = {
//     position: "absolute",
//     top: "50%",
//     transform: "translateY(-50%)",
//     zIndex: 10,
//     background: "rgba(255, 255, 255, 0.95)",
//     backdropFilter: "blur(6px)",
//     borderRadius: "50%",
//     width: "clamp(36px, 5vw, 44px)",
//     height: "clamp(36px, 5vw, 44px)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     border: "2px solid #5dc5fa",
//     color: "#5dc5fa",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
//     cursor: "pointer",
//     transition: "all 0.2s ease",
//     fontSize: "clamp(14px, 2vw, 18px)",
//     padding: 0,
//     outline: "none"
//   };

//   if (loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center px-2">
//           {moduleStyles}
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <motion.h5
//               className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//               initial={{ opacity: 0, y: -30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               Recommended for You
//             </motion.h5>
//           </div>

//           <div className="row gy-4 justify-content-center product-grid-container">
//             {[1, 2, 3, 4].map((n) => (
//               <div key={n} className="col-6 col-sm-4 col-md-4 col-lg-3">
//                 <div className="card h-100 border-0 premium-card-wrapper">
//                   <div className="symmetric-image-frame skeleton-block" />
//                   <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                     <div className="skeleton-block skeleton-title" />
//                     <div className="skeleton-block skeleton-meta" />
//                     <div className="mt-auto w-100">
//                       <div className="skeleton-block skeleton-btn" />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>
//     );
//   }

//   if (filteredProducts.length === 0 && !loading) {
//     return (
//       <section className="popular-section py-4 overflow-hidden">
//         <div className="container text-center">
//           <div className="d-flex justify-content-between align-items-center mb-4">
//             <motion.h5
//               className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//               initial={{ opacity: 0, y: -30 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//             >
//               Recommended for You
//             </motion.h5>
//           </div>
//           <div className="text-center py-5">
//             <p>No products match the selected brand filters.</p>
//             <p className="text-muted small">Try selecting different brands.</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <section className="popular-section py-4">
//       <div className="container text-center px-2">
//         {moduleStyles}

//         {/* Add the ProductModal here */}
//         <ProductModal
//           isOpen={isModalOpen}
//           productId={selectedProductId}
//           onClose={handleCloseModal}
//           refreshCart={refreshCart}
//         />

//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <motion.h5
//             className="fw-bold fs-3 lh-sm mb-0 text-gradient"
//             initial={{ opacity: 0, y: -30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             Recommended for You
//           </motion.h5>
          
//           {filteredProducts.length > 0 && (
//             <motion.button
//               className="view-all-btn"
//               initial={{ opacity: 0, x: 20 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               onClick={handleViewAll}
//             >
//               View All →
//             </motion.button>
//           )}
//         </div>

//         {filteredProducts.length === 0 ? (
//           <div className="text-center py-5">
//             <p>Loading recommended products...</p>
//           </div>
//         ) : (
//           <div className="position-relative px-0 px-md-2">
//             {filteredProducts.length > itemsPerPage && (
//               <>
//                 <button
//                   className="carousel-control-prev premium-arrow-btn-layout"
//                   onClick={() => handleScroll("prev")}
//                   style={{ ...premiumArrowStyle, left: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronLeft />
//                 </button>
//                 <button
//                   className="carousel-control-next premium-arrow-btn-layout"
//                   onClick={() => handleScroll("next")}
//                   style={{ ...premiumArrowStyle, right: window.innerWidth < 768 ? "-8px" : "-44px" }}
//                   onMouseEnter={(e) => {
//                     e.currentTarget.style.background = "#5dc5fa";
//                     e.currentTarget.style.color = "#fff";
//                   }}
//                   onMouseLeave={(e) => {
//                     e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
//                     e.currentTarget.style.color = "#5dc5fa";
//                   }}
//                 >
//                   <FaChevronRight />
//                 </button>
//               </>
//             )}

//             <AnimatePresence mode="wait">
//               <motion.div
//                 key={`${currentSlide}-${itemsPerPage}`}
//                 className="row gy-4 product-grid-container justify-content-start"
//                 initial={{ opacity: 0, x: 40 }}
//                 animate={{ opacity: 1, x: 0 }}
//                 exit={{ opacity: 0, x: -40 }}
//                 transition={{ duration: 0.4, ease: "easeInOut" }}
//                 drag="x"
//                 dragConstraints={{ left: 0, right: 0 }}
//                 dragElastic={0.2}
//                 onDragEnd={(e, info) => {
//                   if (info.offset.x > 50) {
//                     handleScroll("prev");
//                   } else if (info.offset.x < -50) {
//                     handleScroll("next");
//                   }
//                 }}
//               >
//                 {visibleItems[currentSlide]?.map((item) => {
//                   const isSoldOut = item.stock === 0;
//                   const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
//                   const cartQty = cartItems[item.id];
//                   const isLoggedIn = localStorage.getItem("access_token");

//                   return (
//                     <div
//                       key={item.id}
//                       className="col-6 col-sm-4 col-md-4 col-lg-3"
//                     >
//                       <div className="card h-100 border-0 premium-card-wrapper">
//                         <div className="symmetric-image-frame">
//                           {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

//                           <div
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               if (!wishlistLoading) toggleWishlist(item);
//                             }}
//                             style={{
//                               position: "absolute",
//                               top: "10px",
//                               right: "10px",
//                               cursor: "pointer",
//                               zIndex: 2,
//                             }}
//                           >
//                             {isInWishlist ? (
//                               <FaHeart size={20} color="red" />
//                             ) : (
//                               <CiHeart size={20} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />
//                             )}
//                           </div>

//                           <motion.img
//                             src={item.item_photo || logo}
//                             alt={item.title}
//                             className="symmetric-cover-img"
//                             style={{ cursor: "pointer" }}
//                             // Replace navigation with modal handler
//                             onClick={() => handleProductClick(item.id)}
//                           />
//                         </div>

//                         <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
//                           <h6 
//                             className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" 
//                             style={{ fontSize: "14px", cursor: "pointer" }}
//                             onClick={() => handleProductClick(item.id)} // Add click handler to title too
//                           >
//                             {item.title}
//                           </h6>
                          
//                           <div className="d-flex align-items-center flex-wrap gap-1 gap-sm-2 mb-3">
//                             <span className="text-muted text-decoration-line-through mobile-price-size" style={{ fontSize: "13px" }}>
//                               ₹{item.item_old_price || 0}
//                             </span>
//                             <span className="fw-bold text-dark mobile-price-size" style={{ fontSize: "14px" }}>
//                               ₹{item.item_new_price}
//                             </span>
//                             <span className="fw-bold" style={{ color: '#28a745', fontSize: "11px" }}>
//                               {item.discount_percentage}% OFF
//                             </span>
//                           </div>

//                           <div className="mt-auto w-100">
//                             {cartQty && !isSoldOut && isLoggedIn ? (
//                               <div className="d-flex justify-content-center align-items-center gap-1 gap-sm-2">
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => subOne(item.id)}>
//                                   -
//                                 </button>
//                                 <span className="fw-bold text-dark mx-1 mx-sm-2" style={{ fontSize: "13px" }}>{cartQty}</span>
//                                 <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => addOne(item.id)}>
//                                   +
//                                 </button>
//                               </div>
//                             ) : (
//                               <button
//                                 className="btn text-white w-100 fw-bold rounded-pill shadow-none"
//                                 onClick={() => onPressAddToCart(item.id)}
//                                 disabled={isSoldOut}
//                                 style={{ backgroundColor: "#5dc5fa", border: "none", padding: "6px 0", fontSize: "12px" }}
//                               >
//                                 Add to Cart
//                               </button>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </motion.div>
//             </AnimatePresence>

//             {filteredProducts.length > itemsPerPage && (
//               <div className="carousel-dots" style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
//                 {visibleItems.map((_, idx) => (
//                   <button
//                     key={idx}
//                     onClick={() => setCurrentSlide(idx)}
//                     style={{
//                       width: "8px",
//                       height: "8px",
//                       borderRadius: "50%",
//                       background: currentSlide === idx ? "#5dc5fa" : "#ddd",
//                       border: "none",
//                       padding: "0",
//                       cursor: "pointer"
//                     }}
//                   />
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </section>
//   );
// }

// export default Popular;

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Api from "../Utills/Api";
import { useNavigate } from "react-router-dom";
import logo from "../../Frozenwala.png";
import "./Popular.css";
import { CiHeart } from "react-icons/ci";
import { FaHeart, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useWishlist } from "../../contexts/WishlistContext";
import ProductModal from "./ProductModal";

function Popular({ refreshCart, selectedBrands = [] }) {
  const { wishlist, toggleWishlist, wishlistLoading } = useWishlist();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [getProduct, setGetProduct] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [cartItems, setCartItems] = useState({});
  const [stock, setStock] = useState({});
  const [loading, setLoading] = useState(false);
  
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const [itemsPerPage, setItemsPerPage] = useState(4);

  const uid = localStorage.getItem("user_id");
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setItemsPerPage(2);
      } else if (width < 992) {
        setItemsPerPage(3);
      } else {
        setItemsPerPage(4);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedBrands]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const accessToken = localStorage.getItem("access_token");
      const uid = localStorage.getItem("user_id");

      let url = 'https://backend.frozenwala.com/api/recommended/';

      if (selectedBrands && selectedBrands.length > 0) {
        const brandsParam = selectedBrands.join(',');
        url += `?brand=${encodeURIComponent(brandsParam)}`;
      }

      const popularRes = await fetch(url);
      const popularData = await popularRes.json();
      setGetProduct(popularData);
      setFilteredProducts(popularData);

      setCurrentSlide(0);

      try {
        const stockRes = await axios.get(`https://backend.frozenwala.com/api/stock/`);
        const stockMap = {};
        if (stockRes.data && Array.isArray(stockRes.data)) {
          stockRes.data.forEach((item) => (stockMap[item.item_id] = item.openingstock));
          setStock(stockMap);
        }
      } catch (stockErr) {
        console.error("Error fetching stock data:", stockErr);
      }

      if (accessToken && uid) {
        try {
          const cartRes = await Api.get(`api/get_cart/?user_id=${uid}`);
          const cartMap = {};
          if (cartRes.data && Array.isArray(cartRes.data)) {
            cartRes.data.forEach((item) => (cartMap[item.product_id] = item.quantity));
            setCartItems(cartMap);
          }
        } catch (authError) {
          console.log("User not logged in or token expired, skipping cart");
        }
      }
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = (direction) => {
    if (filteredProducts.length === 0) return;
    const totalSlides = Math.ceil(filteredProducts.length / itemsPerPage);
    setCurrentSlide((prev) =>
      direction === "next" ? (prev + 1) % totalSlides : (prev - 1 + totalSlides) % totalSlides
    );
  };

  const handleProductClick = (productId) => {
    setSelectedProductId(productId);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedProductId(null);
  };

  const visibleItems = [];
  for (let i = 0; i < filteredProducts.length; i += itemsPerPage) {
    visibleItems.push(filteredProducts.slice(i, i + itemsPerPage));
  }

  const onPressAddToCart = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/add_to_cart/`, { product_id: productId, u_id: uid });
      setCartItems((prev) => ({
        ...prev,
        [productId]: (prev[productId] || 0) + 1,
      }));
      refreshCart();
    } catch (err) {
      console.error("Add to cart failed:", err);
    }
  };

  const addOne = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    const currentQty = cartItems[productId] || 0;
    const available = stock[productId] || 0;

    if (available > currentQty) {
      try {
        await Api.post(`api/increase/main/`, { product_id: productId, user_id: uid });
        setCartItems((prev) => ({ ...prev, [productId]: currentQty + 1 }));
        refreshCart();
      } catch (err) {
        console.error("Increase failed:", err);
      }
    } else {
      toast.warning(`Only ${available} items in stock`);
    }
  };

  const subOne = async (productId) => {
    const accessToken = localStorage.getItem("access_token");
    if (!accessToken) return navigate("/login");

    try {
      await Api.post(`api/decrease/main/`, { product_id: productId, user_id: uid });
      setCartItems((prev) => {
        const updated = { ...prev };
        if (updated[productId] > 1) updated[productId] -= 1;
        else delete updated[productId];
        return updated;
      });
      refreshCart();
    } catch (err) {
      console.error("Decrease failed:", err);
    }
  };

  const handleViewAll = () => {
    navigate('/recommended-products', { 
      state: { 
        products: filteredProducts,
        selectedBrands: selectedBrands
      } 
    });
  };

  const moduleStyles = (
    <style>{`
      .popular-section {
        overflow: visible !important;
      }
      .premium-card-wrapper {
        border-radius: 20px !important;
        padding: 12px !important;
        background: #ffffff !important;
        border: 1px solid rgba(0, 0, 0, 0.03) !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07) !important;
        transition: transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
      .premium-card-wrapper:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14) !important;
      }
      .symmetric-image-frame {
        position: relative;
        width: 100%;
        height: 180px;
        overflow: hidden;
        border-radius: 14px !important;
        background-color: #f7f7f7;
      }
      .symmetric-cover-img {
        width: 100%;
        height: 100%;
        object-fit: cover !important;
        transition: transform 0.3s ease;
        cursor: pointer;
      }
      .premium-card-wrapper:hover .symmetric-cover-img {
        transform: scale(1.04);
      }

      .symmetric-image-frame::after {
        content: "";
        position: absolute;
        top: 0;
        left: -75%;
        width: 50%;
        height: 100%;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.5) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: skewX(-25deg);
        transition: left 0.4s ease-out;
        pointer-events: none;
        z-index: 2;
      }
      .premium-card-wrapper:hover .symmetric-image-frame::after {
        left: 125%;
      }

      .skeleton-block {
        background: linear-gradient(90deg, #f2f2f2 25%, #e6e6e6 50%, #f2f2f2 75%);
        background-size: 200% 100%;
        animation: skeleton-pulse 1.5s infinite ease-in-out;
      }
      @keyframes skeleton-pulse {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
      .skeleton-title {
        height: 16px;
        width: 75%;
        border-radius: 4px;
        margin-bottom: 12px;
      }
      .skeleton-meta {
        height: 14px;
        width: 50%;
        border-radius: 4px;
        margin-bottom: 20px;
      }
      .skeleton-btn {
        height: 35px;
        width: 100%;
        border-radius: 50px;
      }

      .view-all-btn {
        color: #5dc5fa;
        font-weight: 600;
        font-size: 14px;
        text-decoration: none;
        padding: 6px 16px;
        border-radius: 50px;
        border: 2px solid #5dc5fa;
        background: transparent;
        transition: all 0.3s ease;
        white-space: nowrap;
      }
      .view-all-btn:hover {
        background: #5dc5fa;
        color: #fff;
        transform: translateX(4px);
      }

      @media (max-width: 575.98px) {
        .product-grid-container {
          --bs-gutter-x: 0.5rem !important;
        }
        .premium-card-wrapper {
          padding: 8px !important;
          border-radius: 16px !important;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06) !important;
        }
        .symmetric-image-frame {
          height: 135px;
          border-radius: 10px !important;
        }
        .mobile-title-size {
          font-size: 13px !important;
        }
        .mobile-price-size {
          font-size: 12px !important;
        }
        .view-all-btn {
          font-size: 12px;
          padding: 4px 12px;
        }
      }
    `}</style>
  );

  const premiumArrowStyle = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    background: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(6px)",
    borderRadius: "50%",
    width: "clamp(36px, 5vw, 44px)",
    height: "clamp(36px, 5vw, 44px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "2px solid #5dc5fa",
    color: "#5dc5fa",
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    fontSize: "clamp(14px, 2vw, 18px)",
    padding: 0,
    outline: "none"
  };

  if (loading) {
    return (
      <section className="popular-section py-4 overflow-hidden">
        <div className="container text-center px-2">
          {moduleStyles}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <motion.h5
              className="fw-bold fs-3 lh-sm mb-0 text-gradient"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Recommended for You
            </motion.h5>
          </div>

          <div className="row gy-4 justify-content-center product-grid-container">
            {[1, 2, 3, 4].map((n) => (
              <div key={n} className="col-6 col-sm-4 col-md-4 col-lg-3">
                <div className="card h-100 border-0 premium-card-wrapper">
                  <div className="symmetric-image-frame skeleton-block" />
                  <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
                    <div className="skeleton-block skeleton-title" />
                    <div className="skeleton-block skeleton-meta" />
                    <div className="mt-auto w-100">
                      <div className="skeleton-block skeleton-btn" />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (filteredProducts.length === 0 && !loading) {
    return (
      <section className="popular-section py-4 overflow-hidden">
        <div className="container text-center">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <motion.h5
              className="fw-bold fs-3 lh-sm mb-0 text-gradient"
              initial={{ opacity: 0, y: -30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Recommended for You
            </motion.h5>
          </div>
          <div className="text-center py-5">
            <p>No products match the selected brand filters.</p>
            <p className="text-muted small">Try selecting different brands.</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="popular-section py-4">
      <div className="container text-center px-2">
        {moduleStyles}

        <ProductModal
          isOpen={isModalOpen}
          productId={selectedProductId}
          onClose={handleCloseModal}
          refreshCart={refreshCart}
        />

        <div className="d-flex justify-content-between align-items-center mb-4">
          <motion.h5
            className="fw-bold fs-3 lh-sm mb-0 text-gradient"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Recommended for You
          </motion.h5>
          
          {/* Only show View All button if products > 4 */}
          {filteredProducts.length > 4 && (
            <motion.button
              className="view-all-btn"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              onClick={handleViewAll}
            >
              View All →
            </motion.button>
          )}
        </div>

        {filteredProducts.length === 0 ? (
          <div className="text-center py-5">
            <p>Loading recommended products...</p>
          </div>
        ) : (
          <div className="position-relative px-0 px-md-2">
            {filteredProducts.length > itemsPerPage && (
              <>
                <button
                  className="carousel-control-prev premium-arrow-btn-layout"
                  onClick={() => handleScroll("prev")}
                  style={{ ...premiumArrowStyle, left: window.innerWidth < 768 ? "-8px" : "-44px" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#5dc5fa";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
                    e.currentTarget.style.color = "#5dc5fa";
                  }}
                >
                  <FaChevronLeft />
                </button>
                <button
                  className="carousel-control-next premium-arrow-btn-layout"
                  onClick={() => handleScroll("next")}
                  style={{ ...premiumArrowStyle, right: window.innerWidth < 768 ? "-8px" : "-44px" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#5dc5fa";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.95)";
                    e.currentTarget.style.color = "#5dc5fa";
                  }}
                >
                  <FaChevronRight />
                </button>
              </>
            )}

            <AnimatePresence mode="wait">
              <motion.div
                key={`${currentSlide}-${itemsPerPage}`}
                className="row gy-4 product-grid-container justify-content-start"
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -40 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                dragElastic={0.2}
                onDragEnd={(e, info) => {
                  if (info.offset.x > 50) {
                    handleScroll("prev");
                  } else if (info.offset.x < -50) {
                    handleScroll("next");
                  }
                }}
              >
                {visibleItems[currentSlide]?.map((item) => {
                  const isSoldOut = item.stock === 0;
                  const isInWishlist = wishlist.some((w) => w && w.item && w.item.id === item.id);
                  const cartQty = cartItems[item.id];
                  const isLoggedIn = localStorage.getItem("access_token");

                  return (
                    <div
                      key={item.id}
                      className="col-6 col-sm-4 col-md-4 col-lg-3"
                    >
                      <div className="card h-100 border-0 premium-card-wrapper">
                        <div className="symmetric-image-frame">
                          {isSoldOut && <div className="sold-out-badge" style={{ zIndex: 3 }}>Sold Out</div>}

                          <div
                            onClick={(e) => {
                              e.stopPropagation();
                              if (!wishlistLoading) toggleWishlist(item);
                            }}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              cursor: "pointer",
                              zIndex: 2,
                            }}
                          >
                            {isInWishlist ? (
                              <FaHeart size={20} color="red" />
                            ) : (
                              <CiHeart size={20} color="#fff" strokeWidth={2} style={{ filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.4))" }} />
                            )}
                          </div>

                          <motion.img
                            src={item.item_photo || logo}
                            alt={item.title}
                            className="symmetric-cover-img"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleProductClick(item.id)}
                          />
                        </div>

                        <div className="card-body d-flex flex-column text-start px-1 pt-3 pb-0">
                          <h6 
                            className="fw-bold text-dark text-truncate mb-1 mb-sm-2 mobile-title-size" 
                            style={{ fontSize: "14px", cursor: "pointer" }}
                            onClick={() => handleProductClick(item.id)}
                          >
                            {item.title}
                          </h6>
                          
                          <div className="d-flex align-items-center flex-wrap gap-1 gap-sm-2 mb-3">
                            <span className="text-muted text-decoration-line-through mobile-price-size" style={{ fontSize: "13px" }}>
                              ₹{item.item_old_price || 0}
                            </span>
                            <span className="fw-bold text-dark mobile-price-size" style={{ fontSize: "14px" }}>
                              ₹{item.item_new_price}
                            </span>
                            <span className="fw-bold" style={{ color: '#28a745', fontSize: "11px" }}>
                              {item.discount_percentage}% OFF
                            </span>
                          </div>

                          <div className="mt-auto w-100">
                            {cartQty && !isSoldOut && isLoggedIn ? (
                              <div className="d-flex justify-content-center align-items-center gap-1 gap-sm-2">
                                <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => subOne(item.id)}>
                                  -
                                </button>
                                <span className="fw-bold text-dark mx-1 mx-sm-2" style={{ fontSize: "13px" }}>{cartQty}</span>
                                <button className="btn btn-outline-secondary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', padding: 0 }} onClick={() => addOne(item.id)}>
                                  +
                                </button>
                              </div>
                            ) : (
                              <button
                                className="btn text-white w-100 fw-bold rounded-pill shadow-none"
                                onClick={() => onPressAddToCart(item.id)}
                                disabled={isSoldOut}
                                style={{ backgroundColor: "#5dc5fa", border: "none", padding: "6px 0", fontSize: "12px" }}
                              >
                                Add to Cart
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </motion.div>
            </AnimatePresence>

            {filteredProducts.length > itemsPerPage && (
              <div className="carousel-dots" style={{ display: "flex", justifyContent: "center", gap: "8px", marginTop: "20px" }}>
                {visibleItems.map((_, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentSlide(idx)}
                    style={{
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                      background: currentSlide === idx ? "#5dc5fa" : "#ddd",
                      border: "none",
                      padding: "0",
                      cursor: "pointer"
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default Popular;